import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function usePaymentMethodList(params) {
  return useSWR(
    {
      path: `/api/v1/payment-methods`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default usePaymentMethodList;
